import { isNil } from 'lodash';

export function convertToLowerExceptFirstLetter(word: string): string {
  if (word.length === 0) {
    return '';
  } else if (word.length === 1) {
    return word.toLowerCase();
  } else {
    return word[0] + word.substring(1).toLowerCase();
  }
}

export const formatCurrency = (
  value: number,
  style: 'decimal' | 'currency' = 'currency',
  minimumFractionDigits?: number,
) => {
  // const formatter = new Intl.NumberFormat('en-US', {
  //   style: 'currency',
  //   currency: 'USD',

  //   // These options can be used to round to whole numbers.
  //   trailingZeroDisplay: 'stripIfInteger', // This is probably what most people
  //   // want. It will only stop printing
  //   // the fraction when the input
  //   // amount is a round number (int)
  //   // already. If that's not what you
  //   // need, have a look at the options
  //   // below.
  //   //minimumFractionDigits: 0, // This suffices for whole numbers, but will
  //   // print 2500.10 as $2,500.1
  //   //maximumFractionDigits: 0, // Causes 2500.99 to be printed as $2,501
  // });
  // return formatter.format(value);
  return value?.toLocaleString('en-US', {
    style,
    currency: 'USD',
    minimumFractionDigits: minimumFractionDigits || 0,
  });
};

export const isValidNumber = (value: any): boolean => {
  return !(isNil(value) || value === '');
};
